import React, {Component} from 'react';
//import TestData from './data'
import {Button} from 'semantic-ui-react'
import DocumentCreatorForm from '../documenti/DocumentCreatorForm'
import SenderList from './SenderList'
import CommessaSelect from '../commesse/CommessaSelect'
import LoadingFrame from '../LoadingFrame'
import ErrorMessageTiny from '../ErrorMessageTiny'
import {client} from '../../Client';
import FileSaver from 'file-saver';
import {copiaTestoNegliAppunti} from '../../Helpers';
import Moment from 'moment';
import PropTypes from 'prop-types';

class RubricaDocumentCreator extends Component {
    constructor(props) {
        super(props);
        this.state = {
            commessa: undefined,
            senders: [],
            idDivisione: undefined,
            anno: Moment().format('Y'),
            codiceTipoDocumento: 'ltstd',
            documentoCreato: null,
            _loading:false,
            error: null
        };
    }

    isVisible(){
        return (this.state.senders.length > 0);
    }

    canSave(){
        let rv = (
            this.state.commessa !== undefined &&
            this.state.idDivisione !== undefined &&
            this.state.codiceTipoDocumento !== undefined &&
            this.state.anno !== undefined &&
            this.state.anno !== '' &&
            this.state.anno.length === 4 &&
            /^[1-9][0-9][0-9][0-9]$/.test(this.state.anno) &&
            this.state.senders.length > 0
        )
        return rv;
    }

    componentWillReceiveProps(nextProps){
        let senders = [];
        if (nextProps.senderList.length > 0){
            nextProps.senderList.map((sender) => (
                senders.push(sender)
            ));
        }
        if (nextProps.idDivisione !== undefined){
            this.setState({senders, idDivisione: nextProps.idDivisione.idDivisione});
        }
        else
        {
            this.setState({senders});
        }

    }

    onRemoveSender(sender){
        if (this.props.onRemoveSender !== undefined){
            this.props.onRemoveSender(sender !== undefined ? sender.soggetto : sender)
        }
    }

    onChangeTipo(sender){
        if (this.props.onChangeTipoSender !== undefined){
            this.props.onChangeTipoSender(sender)
        }
    }

    onRubricaCreatorFormChange({idDivisione, codiceTipoDocumento, anno}) {
        this.setState({idDivisione, codiceTipoDocumento, anno});
    }

    onChangeCommessa(commessa){
        this.setState({commessa});
    }

    onCancelClick(){
        this.onRemoveSender(undefined);
    }

    onDownload(documento){
        this.setState({_loading: true})
        client.downloadDocument(documento.idDocumento).then(
            (response) => {
                if (response.ok){
                    response.blob().then((blob) => {
                        this.setState({_loading: false, error: null})
                        FileSaver.saveAs(blob, documento.nome);
                    })
                }
                else if (response.status === 401)
                {
                    this.context.router.transitionTo("/login")
                }
                else
                {
                    response.json().then((errore) => {
                        this.setState({
                            _loading: false,
                            error: {title: errore.title, msg: errore.msg},
                        });
                    });
                }
            }).catch((error) => {
            this.setState({
                _loading: false,
                error: {title: "Errore di rete imprevisto", msg: error.message},
            });

        });
    }

    onSaveClick(){
        let destinatari = [];
        this.state.senders.map((sender) => {
           destinatari.push({
               idSoggetto: sender.soggetto.idSoggetto,
               tipo: sender.tipo,
           });
           return 0;
        });

        this.setState({_loading: true});
        client.saveDocumento(
            {
                idCommessa: this.state.commessa.idCommessa,
                codiceTipoDocumento: this.state.codiceTipoDocumento,
                idDivisione: this.state.idDivisione,
                creatoDa: client.getCurrentUserId(),
                macro: {destinatari, idCommessa: this.state.commessa.idCommessa, idDivisione: this.state.idDivisione},
                anno: this.state.anno
            }
        ).then((response) => {
            if (response.ok){
                response.json().then((data) => {
                    this.setState({
                        _loading: false,
                        error: null,
                        documentoCreato: data
                    });
                    //this.onDownload(data);

                })
            }
            else if (response.status === 401)
            {
                this.context.router.transitionTo("/login")
            }
            else
            {
                response.json().then((errore) => {
                    this.setState({
                        _loading: false,
                        error: {title: errore.title, msg: errore.msg},
                    });
                })
            }
        }).catch((error) => {
            this.setState({
                _loading: false,
                error: {title: "Errore di rete imprevisto", msg: error.message},
            });
        });
    }

    onExportClick(){
        let idSoggetti = [];
        this.state.senders.map((sender) => {
            idSoggetti.push(sender.soggetto.idSoggetto);
            return 0;
        });

        this.setState({_loading: true});
        client.exportCSVSoggettiList(idSoggetti).then((response) => {
            if (response.ok){
                response.blob().then((blob) => {
                    this.setState({_loading: false, error: null})
                    FileSaver.saveAs(blob, 'soggetti.csv');
                })
            }
            else if (response.status === 401)
            {
                this.context.router.transitionTo("/login")
            }
            else
            {
                response.json().then((errore) => {
                    this.setState({
                        _loading: false,
                        error: {title: errore.title, msg: errore.msg},
                    });
                })
            }
        }).catch((error) => {
            this.setState({
                _loading: false,
                error: {title: "Errore di rete imprevisto", msg: error.message},
            });
        });
    }

    onCopiaTesto(value){
        copiaTestoNegliAppunti(value);
    }

    render() {

        if (!this.isVisible())
        {
            return null;
            // return (
            //     <div className="no-print">
            // <Message icon info>
            //     <Icon name='info' />
            //     <Message.Content>
            //         <Message.Header>Creazione lettera</Message.Header>
            //         Clicca sull'icona del documento <i className="icon file outline"/> per aggiungere nuovi destinatari e avviare la procedura di creazione lettera...
            //     </Message.Content>
            // </Message></div>
            // )
        }

        let documentoCreatoMsg = null;
        if (this.state.documentoCreato){
            documentoCreatoMsg = <div className="row">
                <div className="sixteen wide column">
                    <div className="ui info message">
                        <i className="close icon"></i>
                        <div className="header">
                            Documento {this.state.documentoCreato.nome} creato correttamente
                        </div>
                        <ul className="list">
                            <li className="pointer" onClick={() => this.onCopiaTesto(client.adaptClientPath(this.state.documentoCreato.clientFullname))}><i className="icon copy"/> Clicca qui per copiare il path locale del documento sugli appunti.</li>                        
                            {/* <li className="pointer" onClick={() => this.onDownload(this.state.documentoCreato)}><i className="icon download"/> Clicca qui per effettuare il download del documento.</li> */}
                        </ul>
                    </div>
                </div>
            </div>
        }

        return (
            <div className="no-print ui raised segment">
                <h4 className="ui header">Creazione Documento</h4>
            <div className="ui grid three column stackable">

                {documentoCreatoMsg}
                <div className="row">
                <div className="five wide column">
                    <CommessaSelect
                        fluid={true}
                        onChange={(c) => this.onChangeCommessa(c)}
                    />
                </div>
                <div className="seven wide column">
                    <SenderList
                        senderList={this.state.senders}
                        onRemoveSender={(sender)=>(this.onRemoveSender(sender))}
                        onExportClick={() => (this.onExportClick())}
                        onChangeTipo={(sender)=>(this.onChangeTipo(sender))}
                    />
                </div>
                <div className="four wide column">
                    <DocumentCreatorForm
                        codiceTipoDocumento={this.state.codiceTipoDocumento}
                        idDivisione={this.state.idDivisione}
                        inRubrica={true}
                        anno={this.state.anno}
                        onChange={(fields) => (this.onRubricaCreatorFormChange(fields))}
                    />
                    <div className="ui grid">
                        <div className="right aligned eight wide column">
                            <a onClick={() => (this.onCancelClick())} className="ui right floated  secondary  button"><i className="undo icon"/>Annulla</a>
                        </div>
                        <div className="left aligned eight wide column">
                            <Button primary onClick={() => (this.onSaveClick())} disabled={!this.canSave()}><i className="save icon"/> Crea Documento</Button>
                        </div>
                    </div>
                </div>
                </div>


            </div>
                <LoadingFrame visible={this.state._loading}/>
                <ErrorMessageTiny error={this.state.error}  />
            </div>
            )
    }
}

RubricaDocumentCreator.PropTypes = {
    idDivisione: PropTypes.number,
    senderList: PropTypes.array,
    onRemoveSender: PropTypes.func,
    onChangeTipoSender: PropTypes.func,
}

RubricaDocumentCreator.contextTypes = {
    router: PropTypes.object
}
export default RubricaDocumentCreator;



/** WEBPACK FOOTER **
 ** ./src/components/rubrica/RubricaDocumentCreator.js
 **/